import { memo, useMemo } from "react"
import { Box } from "@material-ui/core"
import {
  stateDetailCardSx,
  stateSectionTitleSx,
  stateSummaryBadgeSx,
  themePalette,
} from "./stateTreeStyles"

const formatBadgeLabel = (value) =>
  String(value || "")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")

function StateDetailSummary({
  selectedNode,
  selectedStatus,
}) {
  const statusDeviceInfo = selectedStatus?.status?.device_info || selectedStatus?.device_info

  const deviceModelLabel = useMemo(() => {
    const rawModel =
      selectedStatus?.registration?.model ||
      statusDeviceInfo?.device_model ||
      selectedStatus?.product ||
      selectedStatus?.producto ||
      statusDeviceInfo?.hw_model ||
      selectedNode?.automate?.producto ||
      selectedNode?.automate?.product ||
      selectedNode?.automates?.[0]?.producto ||
      selectedNode?.automates?.[0]?.product ||
      selectedNode?.realtime?.producto ||
      selectedNode?.product ||
      selectedNode?.producto

    if (!rawModel) return null

    return formatBadgeLabel(rawModel)
  }, [
    selectedStatus?.registration?.model,
    selectedNode?.automate?.product,
    selectedNode?.automate?.producto,
    selectedNode?.automates,
    selectedNode?.product,
    selectedNode?.producto,
    selectedNode?.realtime?.producto,
    statusDeviceInfo?.device_model,
    statusDeviceInfo?.hw_model,
    selectedStatus?.product,
    selectedStatus?.producto,
  ])

  const summaryMeta =
    selectedStatus?.mac ||
    selectedNode?.mac ||
    selectedStatus?.product_code ||
    selectedNode?.product_code ||
    selectedStatus?.realtime?.llave ||
    selectedNode?.realtime?.llave ||
    `Nodo #${selectedNode?.id || "-"}`

  return (
    <Box sx={stateDetailCardSx}>
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}>
        <div style={stateSectionTitleSx}>Resumen</div>

        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "0.45rem", paddingTop: "0.2rem", paddingBottom: "0.2rem" }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "0.75rem", flexWrap: "wrap" }}>
            <div style={{ fontSize: "1.05rem", fontWeight: 700, color: themePalette.primary.main, lineHeight: 1.2, marginTop: "0.05rem", marginBottom: "0.2rem" }}>
              {selectedNode?.nombre || statusDeviceInfo?.device_name || "-"}
            </div>

            {deviceModelLabel && (
              <span style={stateSummaryBadgeSx}>
                {deviceModelLabel}
              </span>
            )}
          </Box>

          <div style={{ fontSize: "0.92rem", color: themePalette.text.secondary, lineHeight: 1.35, marginTop: "0.05rem", marginBottom: "0.2rem" }}>
            {summaryMeta}
          </div>

        </Box>
      </Box>
    </Box>
  )
}

export default memo(StateDetailSummary)
